import { Link } from "react-router-dom";

export default function Manifesto() {
  const lines = [
    "We do not trust supply chains.",
    "We trust our hands.",
    "We open every box.",
    "We count every stitch.",
    "We wear the shoes we sell.",
    "We reject what does not pass.",
    "We refund without argument.",
    "We publish every failure.",
    "We answer to the buyer, not the vendor.",
    "We ship slow, because we ship right.",
  ];
  return (
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24">
      <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-6">
        The Manifesto · Signed by the House · 2026
      </p>
      <h1 className="font-serif text-6xl md:text-8xl leading-[0.9] tracking-tighter">
        Ten things we<br />refuse to bend on.
      </h1>

      <ol className="mt-24 space-y-8 max-w-4xl">
        {lines.map((l, i) => (
          <li key={i} className="grid grid-cols-[80px_1fr] gap-6 items-baseline border-b border-foreground/20 pb-8">
            <span className="font-mono text-[hsl(var(--accent))] text-2xl">0{i + 1}.</span>
            <p className="font-serif text-3xl md:text-5xl tracking-tighter leading-[1.1]">{l}</p>
          </li>
        ))}
      </ol>

      <div className="mt-24 border-t-2 border-foreground pt-8 flex justify-between font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
        <span>Signed at the Delhi Hub</span>
        <span>Certif. № TS-2026-M-001</span>
      </div>

      <div className="mt-24 flex gap-4">
        <Link to="/shop" className="bg-foreground text-background px-8 py-4 font-mono text-xs uppercase tracking-[0.24em] hover:bg-[hsl(var(--accent))]">
          Shop the Vault
        </Link>
        <Link to="/spotters" className="border border-foreground px-8 py-4 font-mono text-xs uppercase tracking-[0.24em] hover:bg-foreground hover:text-background">
          Meet the Spotters
        </Link>
      </div>
    </div>
  );
}
